module.exports = __webpack_public_path__ + "img/个人默认头像.3a24c3db.png";